import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampFacilityTypeIcon: React.FC<SVGComponentProps> = ({
  width = 16,
  height = 16
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33203 2.66663V13.3333M1.33203 5.33329H13.332C13.6857 5.33329 14.0248 5.47377 14.2748 5.72382C14.5249 5.97387 14.6654 6.313 14.6654 6.66663V13.3333M1.33203 11.3333H14.6654M3.9987 5.33329V11.3333"
        stroke="#62748E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { BootcampFacilityTypeIcon };
